import { render, staticRenderFns } from "./SelectTown.vue?vue&type=template&id=77f6a7cf&"
import script from "./SelectTown.vue?vue&type=script&lang=js&"
export * from "./SelectTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports